import axios from 'axios'

export const state = {
  currentUser: {},
  selectedOutlet: null,
  currentOutletData: {},
}

export const getters = {
  getUser(state) {
    return state.currentUser
  },
  getSelectedOutlet(state) {
    return state.selectedOutlet
  },
  getCurrentOutletData(state) {
    return state.currentOutletData
  },
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
  },
  SET_SELECTED_OUTLET(state, newValue) {
    state.selectedOutlet = newValue
  },
  SET_CURRENT_OUTLET_DATA(state, newValue) {
    state.currentOutletData = newValue
  },
}

export const actions = {
  fetchUser({ commit, state }, { userId }) {
    return axios.get(`/v1/users/${userId}`).then(response => {
      let filterOutlets = []

      response.data.outlets.forEach(element => {
        let filterData = response.data.outletIds.find(x => x === element.id)
        if (filterData !== undefined) {
          var obj = {
            id: element.id,
            name: element.name,
          }
          filterOutlets.push(obj)
        }
      })

      response.data.outlets = filterOutlets
      const currentUser = response.data
      commit('SET_CURRENT_USER', currentUser)
      return currentUser
    })
  },
  getUserByID({ commit, state }, { userId }) {
    return axios.get(`/v1/users/${userId}`).then(response => {
      return response.data
    })
  },

  getAllUsersInDB() {
    return axios
      .get(`/v1/users/all`)
      .then(response => {
        const users = response.data
        return users
      })
      .catch(err => {
        throw err
      })
  },

  setSelectedOutlet({ commit, state }, { outlet }) {
    return axios.get(`/v1/outlets/${outlet}`).then(response => {
      let currentOutletData = response.data
      currentOutletData.id = outlet
      commit('SET_CURRENT_OUTLET_DATA', currentOutletData)
      commit('SET_SELECTED_OUTLET', outlet)
      return currentOutletData
    })
  },
}

// ===
// Private helpers
// ===

// function getSavedState(key) {
//   return JSON.parse(window.localStorage.getItem(key))
// }

// function saveState(key, state) {
//   window.localStorage.setItem(key, JSON.stringify(state))
// }

// function setDefaultAuthHeaders(state) {
//   axios.defaults.headers.common.Authorization = state.authDetails
//     ? state.authDetails.token
//     : ''
// }
